export default __webpack_public_path__ + "static/media/(2)-EDSF-Release-4-Design-Workshop-20-November-2019.74761463.md";